import { DateInputField } from 'components/Form/DateInputField'
import moment from 'moment'
import { ChangeEvent, useCallback, useEffect, useMemo, useState } from 'react'
import { noop } from 'utils'
import { getDateComponents } from 'utils/helpers'
import { AdvancedInputProps, BasicInputGroup } from '.'

export type DateObject = { __day?: string; __month?: string; __year?: string }
export interface DateInputProps extends AdvancedInputProps {
  value?: string
  maxDate?: {
    year: number
    month: number
    day: number
  }
}

export const DateInput = ({
  name,
  value = '',
  label,
  disabled,
  setFieldValue,
  onBlur = noop,
  error,
  tabIndex,
  maxDate,
}: DateInputProps) => {
  const [{ __day: d, __month: m, __year: y }, setDate] = useState<DateObject>(
    () => getDateComponents(value ? new Date(value).toISOString() : undefined)
  )

  useEffect(() => {
    if (d && m && y) {
      if (maxDate) {
        if (Number(y) >= maxDate.year) {
          if (
            Number(y) > maxDate.year ||
            Number(m) > maxDate.month ||
            (Number(m) === maxDate.month && Number(d) > maxDate.day)
          ) {
            setFieldValue(name, undefined)
            return
          }
        }
      }

      setFieldValue(
        name,
        new Date(`${y}-${m}-${d}T00:00:00.000Z`).toISOString()
      )
    }
    // eslint-disable-next-line
  }, [d, m, y, name, maxDate])

  const handleChange = useCallback(
    (evt: ChangeEvent<HTMLInputElement>) => {
      const {
        target: { name, value },
      } = evt
      setDate((dob) => {
        dob = { ...dob, [name]: value }
        return dob
      })
    },
    [setDate]
  )

  const displayText = useMemo(() => {
    return d && m && y ? moment(`${y}-${m}-${d}`).format('MMM DD, YYYY') : '-'
  }, [d, m, y])
  return (
    <BasicInputGroup
      name={name}
      label={label}
      disabled={disabled}
      error={error}
      display={displayText}
      input={
        <DateInputField
          day={d}
          month={m}
          year={y}
          disabled={disabled}
          tabIndex={tabIndex}
          onChange={handleChange}
          onBlur={onBlur}
          maxDate={maxDate}
        />
      }
    />
  )
}
